import { playAudio } from '../audio/audioActions';

export const START_PLAYING = 'START_PLAYING';
export const STOP_PLAYING = 'STOP_PLAYING';

export const startPlaying = () => ({
    type: START_PLAYING,
});

export const stopPlaying = () => ({
    type: STOP_PLAYING,
});

export const playStimulusAudio = (audioFiles, delay = 0) => (dispatch) => new Promise((resolve) => {
    if (audioFiles && audioFiles.length > 0) {
        return dispatch(playAudio(
            audioFiles,
            delay,
            () => {
                dispatch(startPlaying());
            },
            () => {
                dispatch(stopPlaying());
                resolve();
            },
        ));
    }
    return resolve();
});
